import React, { useState } from "react";
import { useIntl } from "react-intl";
import ModalComponent from "../../components/ModalComponent";
import Toast from "../../helpers/Toast";
import { CheckListModelTaskService } from "../../services/CheckListModelTaskService";

type Props = {
    isOpen: boolean;
    toggle: () => void;
    taskId: number | null;
    onDeleted: () => void;
};

export default function CheckListModelTaskDeleteModal({ isOpen, toggle, taskId, onDeleted }: Props) {
    const intl = useIntl();
    const [loading, setLoading] = useState(false);
    const checkListModelTaskService = new CheckListModelTaskService();

    const handleDelete = async () => {
        if (!taskId) return;

        setLoading(true);
        const response = await checkListModelTaskService.Delete(taskId);
        setLoading(false);

        if (!response.success) {
            Toast.Show("error", response.message);
            return;
        }

        Toast.Show("success", response.message);
        toggle();
        onDeleted();
    };

    return (
        <ModalComponent
            IsOpen={isOpen}
            title={intl.formatMessage({ id: "Screens.CheckListModelTask.Delete.Title" })}
            text={intl.formatMessage({ id: "Screens.CheckListModelTask.Delete.ConfirmationMessage" })}
            OnClickLeft={toggle}
            OnClickRight={handleDelete}
            buttonLeft={intl.formatMessage({ id: "Buttons.Cancel" })}
            buttonRight={intl.formatMessage({ id: "Buttons.Delete" })}
        />
    );
}
